module.exports = __webpack_public_path__ + "static/media/mixkit-magical-coin-win-1936.1aa5ba3d.wav";